"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var helpers_1 = require("@/frontend/helpers");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
// eslint-disable-next-line import/no-cycle
var ApplicationMotivation_1 = __importDefault(require("../ApplicationMotivation"));
var LocalApplicationContext_1 = __importDefault(require("../../context/LocalApplicationContext"));
function ApplicationMotivationContainer() {
    var applicationParam = (0, react_router_dom_1.useParams)().applicationId;
    var currentApplication = (0, react_1.useContext)(LocalApplicationContext_1.default).currentApplication;
    var queryClient = (0, react_query_1.useQueryClient)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var getFormData = function (_a) {
        var motivation = _a.motivation, file = _a.file;
        var formData = new FormData();
        formData.append('motivation', motivation);
        if (file && file.name) {
            formData.append('resume', file);
        }
        return formData;
    };
    var handleUpdate = function (_a) {
        var motivation = _a.motivation, file = _a.file;
        if (!currentApplication) {
            return;
        }
        var formData = getFormData({ motivation: motivation, file: file });
        formData.append('motivation', motivation);
        if (file && file.name) {
            formData.append('resume', file);
        }
        axios_1.default.post("/data/applications/".concat(currentApplication.id, "/motivation"), formData).then(function (_a) {
            var data = _a.data;
            if (data.toasty) {
                (0, helpers_1.toasty)({ message: data.toasty.message, type: data.toasty.type });
            }
        });
    };
    var handleSend = function (_a) {
        var motivation = _a.motivation, file = _a.file;
        if (!currentApplication) {
            return;
        }
        var formData = getFormData({ motivation: motivation, file: file });
        axios_1.default
            .post("/data/applications/".concat(currentApplication.id, "/send"), formData)
            .then(function (_a) {
            var data = _a.data;
            if (data.toasty) {
                (0, helpers_1.toasty)({ message: data.toasty.message, type: data.toasty.type });
            }
            queryClient.invalidateQueries(['application', applicationParam]);
            navigate("/applications/active/".concat(applicationParam, "/motivation"));
        })
            .catch(function (error) {
            (0, helpers_1.toasty)({ message: error.response.data.message, type: 'error' });
        });
    };
    return (0, jsx_runtime_1.jsx)(ApplicationMotivation_1.default, { handleUpdate: handleUpdate, handleSend: handleSend });
}
exports.default = ApplicationMotivationContainer;
